export interface AddFuelSupplierRequest {
  name: string;
  stationManager: string;
  address: string;
  sapId: string;
  remarks: string;
}
